// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-67c09371]{padding-bottom:30px}.groups[data-v-67c09371]{margin-bottom:32px}.groups__notification[data-v-67c09371]{text-align:center;color:#2c353b}", ""]);
// Exports
module.exports = exports;
